export default {
  layout: state => state.layout,
  betslipConfig: state => state.betslipConfig,
  bets: state => state.bets,
  ticket: state => state.ticket,
  meta: state => state.meta,
  showBetslip: state => state.showBetslip,
  payinForbidden: state => state.payinForbidden,
  ticketUnpayable: state => state.ticketUnpayable,
  maxBetAmountErr: state => state.maxBetAmountErr,
  selectedBet: state => state.selectedBet,
  editMode: state => state.editMode,
  totalStake: state => state.totalStake,
  futureBets: state => state.futureBets,

  totalPayment: state => state.totalPayment,
  minPayment: state => state.minPayment,

  getAllBetslipItems: state => state.betslipItems,
  getCurrentBetItem: state => state.currentBetItem,
};
